import React from 'react';
import {
  ToggleButtonGroupProps as MuiToggleButtonGroupProps,
  ToggleButtonGroup as MuiToggleButtonGroup,
  capitalize,
} from '@mui/material';
import { clsx } from 'clsx';
import { toggleButtonGroupClasses } from './types';

export interface ToggleButtonGroupProps extends MuiToggleButtonGroupProps {
  /**
   * Color scheme for ToggleButtons
   * @default "tonal"
   */
  colorVariant?: 'tonal' | 'text' | 'strong';
}

type ClassNamesKey = keyof typeof toggleButtonGroupClasses;

export const ToggleButtonGroup = React.forwardRef(
  (props: ToggleButtonGroupProps, ref: React.RefObject<HTMLButtonElement | unknown>) => {
    const {
      colorVariant = 'tonal',
      className,
      ...rest
    } = props;

    return (
      <MuiToggleButtonGroup
        {...rest}
        ref={ref}
        className={clsx(
          className,
          toggleButtonGroupClasses[`colorVariant${capitalize(colorVariant)}` as ClassNamesKey],
        )}
      />
    );
  },
);

ToggleButtonGroup.defaultProps = {
  colorVariant: 'tonal',
};
